import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import { Badge, Grid } from '@mui/material';
import { black, gold, white } from '../../getLPTheme';
import { options } from '@config';
import IconNotifications from './components/header/headerContainer';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../hooks'
import { menuSelected } from './navigatorSlice';
import { useAppSelector} from '../../hooks'
import { jwtDecode } from 'jwt-decode'; 

const lightColor = 'rgba(255, 255, 255, 0.7)';

const theme = createTheme({
  palette: {
    primary: {
      main: '#7c7c7c',
      light: '#969696',
      dark: '#565656',
      contrastText: '#242105',
    },
    secondary: {
      main: '#bababa',
      light: '#bababa',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#bababa',
    },
  },
});

interface HeaderProps {
  onDrawerToggle: () => void;
}

export default function Header(props: HeaderProps) {

  // icono desplegable
  const [open, setOpen] = React.useState(false);
  const [member, setMember] = React.useState("");
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const navigate = useNavigate();

  const dispatch = useAppDispatch()


  let avatarChange = useAppSelector(state => state.change.value)



  // onClick={() => dispatch(menuSelected(childId))}

  const handleCloseMenu = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpen(false);
  }

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    localStorage.removeItem('CLUB-VIP-JWT');
    localStorage.removeItem('CLUB-VIP-AVATAR');
    localStorage.removeItem('CLUB-VIP-USER');
    setOpen(false);
    navigate('/login');
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);
  // Fin icono desplegable




  
  const { onDrawerToggle } = props

  const [avatar, setAvatar] = React.useState("../../images/profile.png");

  React.useEffect(()=>{
    if(localStorage.getItem("CLUB-VIP-AVATAR")){
        setAvatar(localStorage.getItem("CLUB-VIP-AVATAR"));
    }
    const token = localStorage.getItem('CLUB-VIP-JWT');
    const decodedToken = jwtDecode(token);
    setMember(decodedToken?.numbermembership);
  }, [])

  React.useEffect(()=>{
    if(localStorage.getItem("CLUB-VIP-AVATAR")){
        setAvatar(localStorage.getItem("CLUB-VIP-AVATAR"));
    }
  }, [avatarChange])



  return (
    <React.Fragment>
    <ThemeProvider theme={theme}>
      <Box sx={{p: 1,m:0, backgroundColor: black[1000], display:"flex", height: 100, width:"100%", direction:"row",  alignItems: "start"}}>
        <Grid sx={{ display: { sm: 'none', xs: 'block' } }} item>
          <IconButton
            color="primary"
            aria-label="open drawer"
            onClick={onDrawerToggle}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
        </Grid>
        <Grid container spacing={0} sx={{p:0, m:0}}>
          <Grid item xs={9} md={9} lg={9} sx={{m:0, p:0}}>
            <Box sx={{p:2, display:"flex", width:"100%", alignItems: "center", direction:"row", justifyContent:"flex-start"}}>
              <Typography sx={{pl: 1, color:gold[500], display:"grid", fontSize: {xs: '3vw', md: '2vw'}, alignItems: "start", direction:"row", justifyContent:"flex-start"}}>
                {member}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3} md={3} lg={3} sx={{m:0, p:0}}>
            <Box sx={{ width:"100%", display:"flex", alignItems: "center", direction:"row", justifyContent:"flex-end"}}>
              <Button sx={{p:0, m:0}} onClick={() => {dispatch(menuSelected('Notificaciones'))}}>
                  <IconNotifications/>
              </Button>
              <Button
                ref={anchorRef}
                id="composition-button"
                aria-controls={open ? 'composition-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                sx={{pb:0.4, m:0}}
              >
                <Avatar sx={{m:0, p:0, bgcolor: black[1000], width: {xs: 40, md: 40, lg: 40, xl: 40}, height: {xs: 40, md: 40, lg: 40, xl: 40}}} src={avatar} alt="My Avatar" />
              </Button>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
                sx={{hegiht:30, p:0, m:0}}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom-start' ? 'left center' : 'left center',
                    }}
                  >
                    <Box sx={{display:"flex", alignItems: "center", direction:"row", justifyContent:"center"}}>
                      <Paper sx={{p:0, m:0, bgcolor: black[1000], height:30, color: white[50], border: 1, borderColor: gold[500]}}>
                        <ClickAwayListener onClickAway={handleCloseMenu}>
                          <MenuList
                            autoFocusItem={open}
                            id="composition-menu"
                            aria-labelledby="composition-button"
                            onKeyDown={handleListKeyDown}
                            sx={{m:0, p:0}}
                          >
                            <MenuItem onClick={handleClose} sx={{pt:0, pb:0, fontSize: {xs: '3vw', md: '1vw', lg: '1vw', xl: '1vw'} }}>Cerrar Sesión</MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Box>
                  </Grow>
                )}
              </Popper>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ThemeProvider>
    </React.Fragment>
  );
}
